import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
const T = function (key, p) {
  if (p === void 0) {
    p = {};
  }
  return app.translator.trans(`linkrobins-lr-home.forum.footer.${key}`, p);
};
/**
 * The site footer, in the shape of linkrobins.com's: a brand column with the
 * blurb and socials, then Products / Resources / Company link columns, and a
 * bottom bar with the copyright and the legal pages. Mounted site-wide by
 * overriding core's empty Footer component. Only links to pages that exist on
 * next — Contact is a mailto until the form is built.
 */
// width/height give the browser the wordmark's shape before it loads (no
// layout nudge; Lighthouse "unsized images"). They are the uploaded logos'
// own ratio; CSS sets the height. See logo() for the footer-size copies.
export default class SiteFooter extends Component {
  view() {
    return m("div", {
      className: "LrFooter"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "LrFooter-top"
    }, m("div", {
      className: "LrFooter-brand"
    }, m(Link, {
      className: "LrFooter-home",
      href: "/",
      "aria-label": app.forum.attribute('title')
    }, this.logo()), m("p", {
      className: "LrFooter-blurb"
    }, T('blurb')), m("p", {
      className: "LrFooter-quip"
    }, T('quip')), m("div", {
      className: "LrFooter-socials"
    }, [['fab fa-x-twitter', 'https://x.com/linkrobinsllc'], ['fab fa-github', 'https://github.com/linkrobins']].map(_ref => {
      let [icon, href] = _ref;
      return m("a", {
        href: href,
        target: "_blank",
        rel: "noopener",
        "aria-label": href
      }, m(Icon, {
        name: icon
      }));
    }))), this.row([{
      label: T('services_uptime'),
      href: '/#uptime'
    }, {
      label: T('services_pricing'),
      href: '/#pricing'
    },
    // /all IS the updates list on this site, so it carries that name.
    {
      label: T('resources_updates'),
      route: 'index'
    }, {
      label: T('resources_wall'),
      route: 'lr.wall'
    }, {
      label: T('resources_wiki'),
      href: '/wiki'
    }, {
      label: T('resources_support'),
      href: '/support'
    },
    // Karl's own public status page for the site (2026-09-13).
    {
      label: T('resources_status'),
      href: '/status/uptime'
    }, {
      label: T('company_about'),
      route: 'lr.about'
    }, {
      label: T('company_contact'),
      route: 'lr.contact',
      open: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/ContactModal', webpackMode: 'lazy-once' */ './ContactModal'))
    }, {
      label: T('company_tips'),
      route: 'lr.tips',
      open: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/TipModal', webpackMode: 'lazy-once' */ './TipModal'))
    }])), m("div", {
      className: "LrFooter-bar"
    }, m("span", {
      className: "LrFooter-copy"
    }, T('copyright', {
      year: new Date().getFullYear()
    })), m("span", {
      className: "LrFooter-legal"
    }, m(Link, {
      href: app.route('lr.privacy')
    }, T('legal_privacy')), m(Link, {
      href: app.route('lr.cookie')
    }, T('legal_cookies')), m(Link, {
      href: app.route('lr.terms')
    }, T('legal_terms'))))));
  }

  /** Both logos, swapped by theme like the header — the light one has dark ink. */
  logo() {
    const hasLogo = app.forum.attribute('logoUrl');
    const hasDark = app.forum.attribute('logoDarkModeUrl');
    const title = app.forum.attribute('title');
    if (!hasLogo) return m("strong", {
      className: "LrFooter-wordmark"
    }, title);
    // Shipped footer-size copies of the uploaded logos (public/brand): the
    // 437x120 uploads are ~20 KB each and the footer draws them 32px tall.
    // 235x64 is 2x, sharp on phones, at ~6.5 KB.
    const base = app.forum.attribute('baseUrl') + '/lr/brand/';
    return [m("img", {
      className: "LrFooter-logo",
      src: base + 'footer-logo.webp',
      alt: title,
      width: "235",
      height: "64",
      loading: "lazy",
      decoding: "async"
    }), hasDark ? m("img", {
      className: "LrFooter-logo LrFooter-logo--dark",
      src: base + 'footer-logo-dark.webp',
      alt: title,
      width: "235",
      height: "64",
      loading: "lazy",
      decoding: "async"
    }) : null];
  }

  /**
   * The whole footer nav as one list; the CSS lays it out in columns. Keeps
   * the guard the old column() had:
   * an item whose route no longer exists is dropped rather than throwing —
   * app.route() raises on an unknown name, and this footer is on every page.
   */
  row(items) {
    return m("nav", {
      className: "LrFooter-links",
      "aria-label": T('services_title')
    }, m("ul", null, items.filter(i => i.href || i.route && app.routes[i.route]).map(i => m("li", null, i.open ? m("button", {
      type: "button",
      className: "LrFooter-linkButton",
      onclick: () => i.open()
    }, i.label) : i.route ? m(Link, {
      href: app.route(i.route, i.params)
    }, i.label) : m("a", {
      href: i.href
    }, i.label)))));
  }
}
flarum.reg.add('linkrobins-lr-home', 'forum/components/SiteFooter', SiteFooter);flarum.reg.addChunkModule('87', '689', 'linkrobins-lr-home', 'forum/components/ContactModal');
flarum.reg.addChunkModule('914', '707', 'linkrobins-lr-home', 'forum/components/TipModal');
flarum.reg.addChunkModule('87', '689', 'linkrobins-lr-home', 'forum/components/settleModalTop');